import { useMutation } from 'react-query'
import { api } from '../../../api'

const deleteRequest = async (id: number) => {
  return api.delete(`/requests/${id}`)
}

export const useRequestDeleteMutation = () => {
  return useMutation('delete-request', {
    mutationFn (id: number) {
      return deleteRequest(id)
    }
  })
}
